import React, { useEffect } from 'react';
import { FormInputSelect } from '../../../../common/formInputsV2/FormInputSelect';
import { garanzie_assicurato } from '../../../../utils/globalCasaConstants';
import {
  GaranzieContainer,
  HeaderContainer,
  SectionContainer,
  GaranziaItem,
  GaranziaHeader,
  CheckboxWrapper,
  ParameterContainer,
} from './DatiAssicuratoStep.styles';

function DatiAssicuratoStep({
  formDataFlow,
  fields,
  replace,
  update,
}) {
  // // Initialize field array when formula changes
  // useEffect(() => {
  //   if (formDataFlow.insurance_formula && fields.length === 0) {
  //     const availableGaranzie = garanzie_assicurato
  //       .filter((g) => g.show_when_formula.includes(formDataFlow.insurance_formula))
  //       .map((g) => {
  //         let isRequired = false;

  //         if (formDataFlow.insurance_formula === '111' && g.cod_garanzia === 'RCVP') {
  //           isRequired = true;
  //         }

  //         if (formDataFlow.insurance_formula === '112' && g.cod_garanzia === 'RCVC') {
  //           isRequired = true;
  //         }

  //         return {
  //           cod_garanzia: g.cod_garanzia,
  //           desc_garanzia: g.desc_garanzia,
  //           selected: isRequired,
  //           parameters: {},
  //           parametersConfig: g.parameters || [],
  //           disabled: isRequired,

  //         };
  //       });

  //     replace(availableGaranzie);
  //   }
  // }, [formDataFlow.insurance_formula, replace]);
  useEffect(() => {
    if (!formDataFlow.insurance_formula) return;

    const availableGaranzie = garanzie_assicurato
      .filter((g) => g.show_when_formula.includes(formDataFlow.insurance_formula))
      .map((g) => {
        // try to find existing field
        const existing = fields.find(
          (f) => f.cod_garanzia === g.cod_garanzia,
        );

        let isRequired = false;

        if (
          formDataFlow.insurance_formula === '111'
          && g.cod_garanzia === 'RCVP'
        ) {
          isRequired = true;
        }

        if (
          formDataFlow.insurance_formula === '112'
          && g.cod_garanzia === 'RCVC'
        ) {
          isRequired = true;
        }

        return {
          cod_garanzia: g.cod_garanzia,
          desc_garanzia: g.desc_garanzia,

          // preserve previous selected & parameters if exist
          selected: existing ? existing.selected : isRequired,
          parameters: existing ? existing.parameters : {},
          parametersConfig: g.parameters || [],
          disabled: isRequired,
        };
      });

    replace(availableGaranzie);
  }, [formDataFlow.insurance_formula]);

  // Handle checkbox change
  const handleCheckboxChange = (index) => {
    const field = fields[index];
    update(index, {
      ...field,
      selected: !field.selected,
    });
  };

  // Handle parameter change
  const handleParameterChange = (index, paramName, value) => {
    const field = fields[index];
    update(index, {
      ...field,
      parameters: {
        ...field.parameters,
        [paramName]: value,
      },
    });
  };

  // Check if parameter has error
  const hasParameterError = (field, paramName) => field.selected && !field.parameters[paramName];

  return (
    <GaranzieContainer>
      <HeaderContainer>
        <h3>Garanzie bene assicurato</h3>
      </HeaderContainer>

      <SectionContainer>
        {fields.map((field, index) => {
          const hasErrors = field.parametersConfig?.some(
            (param) => hasParameterError(field, param.cod_param),
          );
          const hasSuccess = field.selected && !hasErrors;

          return (
            <GaranziaItem key={field.id} hasError={hasErrors} hasSuccess={hasSuccess}>
              <GaranziaHeader>
                <CheckboxWrapper>
                  <input
                    type="checkbox"
                    id={`garanzia-${field.cod_garanzia}`}
                    checked={field.selected || false}
                    onChange={() => handleCheckboxChange(index)}
                    disabled={field.disabled || false}
                  />
                  <label htmlFor={`garanzia-${field.cod_garanzia}`}>
                    {field.desc_garanzia}
                  </label>
                </CheckboxWrapper>
              </GaranziaHeader>

              {/* Render parameters if selected */}
              {field.selected && field.parametersConfig?.length > 0 && (
                <ParameterContainer>
                  {field.parametersConfig.map((param, paramIndex) => (
                    <FormInputSelect
                      key={`${field.cod_garanzia}-param-${paramIndex}`}
                      label={param.desc_parameter.toUpperCase()}
                      placeholder={`Seleziona ${param.desc_parameter}`}
                      options={param.options.map((opt) => ({
                        id: opt.valore,
                        name: opt.label,
                      }))}
                      value={field.parameters[param.cod_param] || ''}
                      onChange={(value) => handleParameterChange(index, param.cod_param, value)}
                      error={
                        hasParameterError(field, param.cod_param)
                          ? 'Campo obbligatorio'
                          : ''
                      }
                      valid={
                        field.selected && field.parameters[param.cod_param]
                      }
                    />
                  ))}
                </ParameterContainer>
              )}
            </GaranziaItem>
          );
        })}
      </SectionContainer>
    </GaranzieContainer>
  );
}

export default DatiAssicuratoStep;
